import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=21527b16&scoped=true"
import script from "./Offer.vue?vue&type=script&lang=js"
export * from "./Offer.vue?vue&type=script&lang=js"
import style0 from "./Offer.vue?vue&type=style&index=0&id=21527b16&prod&scoped=true&lang=css"
import style1 from "./Offer.vue?vue&type=style&index=1&id=21527b16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21527b16",
  null
  
)

export default component.exports